/* nh2 — homepage 2026. Reveal-on-scroll, best-seller tabs, add to cart.
   Every behaviour degrades to static content without JavaScript. */
(function () {
  'use strict';

  if (window.__nh2Home) return;
  window.__nh2Home = true;

  document.documentElement.classList.add('nh2-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- reveal ------------------------------------------------------------ */
  var observer = null;

  function reveal(scope) {
    var items = (scope || document).querySelectorAll('[data-nh2-reveal]:not(.is-in)');
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );
    }
    Array.prototype.forEach.call(items, function (el) {
      observer.observe(el);
    });
  }

  /* ---- best-seller tabs --------------------------------------------------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-nh2-tab]');
    var cards = root.querySelectorAll('[data-nh2-cat]');
    if (!tabs.length) return;

    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var want = tab.getAttribute('data-nh2-tab');
        Array.prototype.forEach.call(tabs, function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        Array.prototype.forEach.call(cards, function (card) {
          var show = want === 'all' ? card.getAttribute('data-nh2-all') !== 'false' : card.getAttribute('data-nh2-cat') === want;
          card.hidden = !show;
          if (show) card.classList.add('is-in');
        });
      });
    });
  }

  /* ---- add to cart --------------------------------------------------------
     The store's drawer is Rebuy Smart Cart, which binds the header cart icon,
     so after a successful add the icon is clicked (same as pdp2.js). Any
     failure falls back to the native form POST. */
  function openCartDrawer() {
    var trigger = document.querySelector('[data-js-cart-icon], [data-cart-link], a[href$="/cart"]');
    if (trigger) trigger.click();
    else window.location.href = '/cart';
  }

  function initForms(root) {
    if (!window.fetch) return;
    Array.prototype.forEach.call(root.querySelectorAll('form[data-nh2-add]'), function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            if (btn) btn.removeAttribute('aria-busy');
            openCartDrawer();
          })
          .catch(function () {
            if (btn) btn.removeAttribute('aria-busy');
            form.submit();
          });
      });
    });
  }

  /* ---- rail arrows ------------------------------------------------------- */
  function initRail(root) {
    var rail = root.querySelector('[data-nh2-rail]');
    if (!rail) return;
    var step = function (dir) {
      var tile = rail.firstElementChild;
      var w = tile ? tile.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: dir * w, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    var prev = root.querySelector('[data-nh2-rail-prev]');
    var next = root.querySelector('[data-nh2-rail-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ---- before / after slider --------------------------------------------
     A native range input sits over the image (keyboard and screen readers get
     a real slider); its value moves the clip and the handle. */
  function initBeforeAfter(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-nh2-ba]'), function (ba) {
      var range = ba.querySelector('[data-nh2-ba-range]');
      if (!range) return;
      var set = function () { ba.style.setProperty('--nh2-pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-nh2]'), function (section) {
      if (section.dataset.nh2Init) return;
      section.dataset.nh2Init = '1';
      initTabs(section);
      initForms(section);
      initRail(section);
      initBeforeAfter(section);
    });
    reveal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-init a section when it is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
